export const INSTAGRAM_URL = "https://www.instagram.com/kyahraynefoundation/";
export const FACEBOOK_URL =
  "https://www.facebook.com/Kyah-Rayne-Foundation-105676284120626";
export const LINKEDIN_URL =
  "https://www.linkedin.com/company/kyah-rayne-foundation";
export const TWITTER_URL = "https://twitter.com/KyahRayne";
export const NATIONAL_EPICOURSE_SCHOOLS_LINK =
  "https://www.kyahsepicourse.com/course/view.php?id=8";
export const AZ_EPICOURSE_SCHOOLS_LINK =
  "https://moodle.publichealth.arizona.edu/course/view.php?id=603";
export const EPICOURSE_FOOD_SERVICE_LINK =
  "https://www.kyahsepicourse.com/course/view.php?id=3";
export const SUBSCRIBE_TO_NEWSLETTER_LINK =
  "https://kyahraynefoundation.us1.list-manage.com/subscribe?u=69716092fda5b8ecfebe0494e&id=ff12db3551";

export const NationalEPICourseForSchoolsEnrollmentVideo =
  "https://player.vimeo.com/video/1020302165";

export const KRF_IMPACT_VIDEO_URL = "https://vimeo.com/1083644070";
export const KRF_IMPACT_VIDEO_EMBED_URL =
  "https://player.vimeo.com/video/1083644070";

export const MARICOPA_SSMP_ENROLLMENT_SITE =
  "https://www.maricopa.gov/5038/Rescue-Medication-Surveillance";

export const ALLERGIC_LIVING_STORY_URL =
  "https://www.allergicliving.com/thisallergiclife/in-mexico-we-lost-my-girl-to-a-taste-of-peanut/";
